(function () {
  var CARD_SELECTORS =
    '.loox-carousel-card-item, .loox-carousel-testimonial-item, .loox-carousel-item, .review-item__content';

  function getCards(root) {
    return root.querySelectorAll(CARD_SELECTORS);
  }

  function equalizeLooxHeights() {
    var root = document.getElementById('looxCarousel');
    if (!root) return false;

    var cards = getCards(root);
    if (!cards.length) return false;

    cards.forEach(function (card) {
      card.style.minHeight = '';
      card.style.height = '';
    });

    root.querySelectorAll('.swiper-slide').forEach(function (slide) {
      slide.style.height = 'auto';
    });

    var maxHeight = 0;
    cards.forEach(function (card) {
      maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
    });

    if (maxHeight > 0) {
      cards.forEach(function (card) {
        card.style.minHeight = maxHeight + 'px';
      });

      root.querySelectorAll('.swiper-slide').forEach(function (slide) {
        slide.style.height = maxHeight + 'px';
      });
    }

    return true;
  }

  function boot() {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (equalizeLooxHeights() || tries > 40) {
        clearInterval(timer);
      }
    }, 250);

    window.addEventListener('resize', equalizeLooxHeights);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('looxCarousel');
    if (!root || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      equalizeLooxHeights();
    });

    observer.observe(root, { childList: true, subtree: true, attributes: true });
  });
})();
